module.exports = __webpack_public_path__ + "img/martin-horst.b9bb4fa7.jpg";